const inFlight = new Map();
/* istanbul ignore next -- DOM injection; exercised via the mount test's mock */
export function loadModuleScript(url) {
    const existing = inFlight.get(url);
    if (existing)
        return existing;
    const promise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = url;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load web component bundle: ${url}`));
        document.head.appendChild(script);
    }).catch((error) => {
        // Drop the cached rejection so a later remount can retry after a transient failure.
        inFlight.delete(url);
        throw error;
    });
    inFlight.set(url, promise);
    return promise;
}
